import { useTranslation } from 'react-i18next'
import React, { useEffect, useState } from 'react'
import { IApplicationState } from 'Store/types'
import { useSelector } from 'react-redux'
import { setVehicleOptions } from '../../Actions/reducer'
import { getVehicleOptions } from 'Application/Visits/Actions/action'
import LoadingPage from 'Layouts/LoadingPage/LoadingPage'
import { useAppDispatch } from 'Hooks/reduxHooks'
import DataNotFoundPage from 'Layouts/DataNotFoundPage/DataNotFoundPage'
import Icon from 'Components/Icon'
import BottomSheet from 'Components/BottomSheet'

const GetOptionsPage = (props: { handleNext: () => void; handleBack: () => void }) => {
  const [t] = useTranslation()
  const { vehicleOptions } = useSelector((store: IApplicationState) => store.visits.newVisit)
  const { vehicleOptionsLoading, vehicleOptionsLoaded, data } = useSelector(
    (store: IApplicationState) => store.visits.vehicleOptionList,
  )
  const dispatch = useAppDispatch()
  const [nextModalVisible, setNextModalVisible] = useState(false)

  useEffect(() => {
    if (!vehicleOptionsLoaded && !vehicleOptionsLoading) getOptionsData()
    else if (!(vehicleOptions && vehicleOptions.length > 0)) {
      data?.map((option: any) => {
        if (option?.vehicleOptionDetails?.some((x: any) => x.isDefault))
          dispatch(
            setVehicleOptions({
              vehicleOptionId: option.id,
              vehicleOptionDetailId: option.vehicleOptionDetails.find((x: any) => x.isDefault)?.id,
            }),
          )
      })
    }
  }, [])

  const getOptionsData = () => {
    dispatch(getVehicleOptions()).then((res: any) => {
      if (res.payload) {
        res.payload?.map((option: any) => {
          if (option?.vehicleOptionDetails?.some((x: any) => x.isDefault))
            dispatch(
              setVehicleOptions({
                vehicleOptionId: option.id,
                vehicleOptionDetailId: option.vehicleOptionDetails.find((x: any) => x.isDefault)
                  ?.id,
              }),
            )
        })
      }
    })
  }

  const isDefaults = (): boolean => {
    let result = true

    data?.map((option: any) => {
      if (
        vehicleOptions.find(x => x.vehicleOptionId == option.id)?.vehicleOptionDetailId !=
        option.vehicleOptionDetails.find((y: any) => y.isDefault)?.id
      )
        result = false
    })

    return result
  }

  const submitForm = () => {
    if (data?.length == vehicleOptions.length) props.handleNext()
  }

  return (
    <React.Fragment>
      <div className="flex flex-col grow overflow-auto">
        <div className="px-6 pb-6">
          <div className="text-sm mb-8">{t('SELECT-THE-OPTIONS')}:</div>

          {vehicleOptionsLoading ? (
            <LoadingPage />
          ) : vehicleOptionsLoaded ? (
            <div className="space-y-4">
              {data?.map((option: any) => {
                return (
                  <div>
                    {option.name}
                    <div
                      className="flex space-x-4"
                      key={`Option-${option.id}`}
                      style={{ marginTop: '8px', marginBottom: '8px' }}
                    >
                      {option?.vehicleOptionDetails?.map((optionDetail: any) => {
                        return (
                          <div
                            className="flex items-center me-4 mb-3"
                            style={{ marginRight: '10px' }}
                          >
                            <input
                              id={`OptionDetail-${option.id}-${optionDetail.id}`}
                              name={`OptionDetail-${option.id}-${optionDetail.id}`}
                              type="radio"
                              value={optionDetail.id}
                              checked={
                                vehicleOptions.find(x => x.vehicleOptionId == option.id)
                                  ?.vehicleOptionDetailId == optionDetail.id
                              }
                              onChange={e => {
                                dispatch(
                                  setVehicleOptions({
                                    vehicleOptionId: option.id,
                                    vehicleOptionDetailId: optionDetail.id,
                                  }),
                                )
                              }}
                              className="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600"
                            />
                            <label
                              htmlFor={`OptionDetail-${option.id}-${optionDetail.id}`}
                              className="ms-2 text-sm font-medium text-gray-900 dark:text-gray-300"
                              style={{ marginRight: '8px' }}
                            >
                              {optionDetail.name}
                            </label>
                          </div>
                        )
                      })}
                    </div>
                  </div>
                )
              })}
            </div>
          ) : (
            <DataNotFoundPage message="اطلاعات آپشن ها یافت نشد." />
          )}
        </div>
      </div>

      <BottomSheet title="" visible={nextModalVisible} onCancel={() => setNextModalVisible(false)}>
        <div
          style={{
            width: 50,
            height: 6,
            backgroundColor: '#ccc',
            borderRadius: 3,
            position: 'absolute',
            top: 8,
            left: '50%',
            transform: 'translateX(-50%)',
          }}
        />

        <div className="overflow-auto px-6 pb-6">
          <div className="text-black text-sm mb-4">{t('OPTIONS_NO_CHANGE_MESSAGE')}</div>
        </div>

        <div className="cta flex flex-col gap-4">
          <button
            type="button"
            className="btn btn-primary btn-lg flex items-center justify-center w-full"
            disabled={false}
            onClick={submitForm}
          >
            {t('NEXT')}
          </button>

          <button
            type="button"
            className="btn btn-error btn-lg flex items-center justify-center w-full"
            disabled={false}
            onClick={() => setNextModalVisible(false)}
          >
            {t('CANCEL')}
          </button>
        </div>
      </BottomSheet>

      <div className="cta">
        {!vehicleOptionsLoading && !vehicleOptionsLoaded && (
          <button
            className="btn btn-info btn-lg flex gap-2 items-center justify-center w-full"
            onClick={() => getOptionsData()}
          >
            {t('GET_OPTIONS')}
          </button>
        )}
        <div className="flex justify-between items-center gap-2">
          <button
            className="btn btn-warning btn-lg flex gap-2 items-center justify-center w-full"
            onClick={props.handleBack}
          >
            <Icon name="arrow-right" className="w-6 h-6" />
            {t('BACK')}
          </button>
          <button
            className="btn btn-primary btn-lg flex gap-2 items-center justify-center w-full"
            disabled={data?.length > vehicleOptions.length}
            onClick={() => {
              if (isDefaults()) setNextModalVisible(true)
              else submitForm()
            }}
          >
            {t('NEXT')}
            <Icon name="arrow-left" className="w-6 h-6" />
          </button>
        </div>
      </div>
    </React.Fragment>
  )
}

export default GetOptionsPage
